module.exports = __webpack_public_path__ + "resources/img/img_magic_sso.e7295fe532b4c302d4d88fde7b17c01d.png";